import PayoutsDataSelectors from './PayoutsData/PayoutsDataSelectors';
import PayoutsHistorySelectors from './PayoutsHistory/PayoutsHistorySelectors';

export default {
	data: PayoutsDataSelectors,
	history: PayoutsHistorySelectors,
};
